import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["setMessage"] = "ariaLive/set";
    ActionTypes["reset"] = "ariaLive/reset";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    setMessage: createAction(ActionTypes.setMessage, (ariaLive) => ({
        payload: ariaLive
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    }))
};
